module.exports = __webpack_public_path__ + "static/media/Blue.904e819d.svg";